import {
  type Appearance,
  loadStripe,
  type SetupIntentResult,
  type StripeElementsOptions,
  type StripePaymentElementChangeEvent,
} from "@stripe/stripe-js";
import { StripeForm } from "@/components/fragments/stripe";
import { FormControl, FormLabel } from "@/components/essentials/form-control";
import { Elements } from "@stripe/react-stripe-js";
import { type FC } from "react";
import { billingFormElementsTestId, billingFormId, billingFormLabelTestId, billingFormTestId } from "./const";
import { getStripePublicKey } from "./module";
import { Box } from "@/components/essentials/box";
import { Typography } from "@/components/essentials/typography";
import Link from "next/link";
import { toysubCvcUrl } from "@/configs/externalUrls";

export interface BillingFormProps {
  readonly clientSecret: StripeElementsOptions["clientSecret"];
  readonly onSubmit: (confirmSetup: () => Promise<SetupIntentResult | undefined>) => Promise<void>;
  readonly onChange: (event: StripePaymentElementChangeEvent) => void;
}

export const BillingForm: FC<BillingFormProps> = ({ clientSecret, onSubmit, onChange }) => {
  const appearance: Appearance = {
    theme: "flat",
  };
  const stripePromise = loadStripe(getStripePublicKey());

  const stripeElementsOptions: StripeElementsOptions = {
    clientSecret,
    appearance,
  };

  return (
    <Box id={billingFormId}>
      <FormControl isRequired data-testid={billingFormTestId}>
        <FormLabel data-testid={billingFormLabelTestId}>お支払い情報</FormLabel>
        <Elements stripe={stripePromise} options={stripeElementsOptions} data-testid={billingFormElementsTestId}>
          <StripeForm
            onSubmit={(e) => {
              // biome-ignore lint/complexity/noVoid :[AUTOMATICALLY-INSERTED] The use of void is not allowed.
              void onSubmit(e);
            }}
            onChange={onChange}
          />
        </Elements>
        <Typography variant="text4" color="gray.dark" mt="2">
          CVCコードは、クレジットカードの表 / 裏面に記載されている3 or 4桁の数字です。詳細は{" "}
          <Typography
            as={Link}
            href={toysubCvcUrl}
            variant="text4"
            color="gray.dark"
            target="_blank"
            rel="noopener"
            textDecorationLine="underline"
          >
            こちら
          </Typography>{" "}
          をご確認ください。
        </Typography>
      </FormControl>
    </Box>
  );
};
